import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.pages.route404;

// STYLES

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
